<div class="mydp" [ngStyle]="{ width: opts.showInputField ? opts.width : null, border: opts.inline ? 'none' : null }">
	@if (!opts.inline) {
		<div class="selectiongroup">
			@if (opts.showInputField) {
				<input
					#inputBoxEl
					autocomplete="off"
					autocorrect="off"
					class="selection"
					ngtype="text"
					placeholder="{{ placeholder }}"
					spellcheck="false"
					[attr.aria-label]="opts.ariaLabelInputField"
					[disabled]="opts.componentDisabled"
					[ngClass]="{
						invaliddate: invalidDate && opts.indicateInvalidDate,
						inputnoteditable: opts.openSelectorOnInputClick && !opts.editableDateField,
						selectiondisabled: opts.componentDisabled,
					}"
					[ngModel]="selectionDayTxt"
					[ngStyle]="{ height: opts.height, 'font-size': opts.selectionTxtFontSize }"
					[readonly]="!opts.editableDateField"
					[value]="selectionDayTxt"
					(blur)="opts.editableDateField && onBlurInput($event)"
					(click)="opts.openSelectorOnInputClick && !opts.editableDateField && openBtnClicked()"
					(focus)="opts.editableDateField && onFocusInput($event)"
					(keyup)="onCloseSelector($event)"
					(ngModelChange)="onUserDateInput($event)"
				/>
			}
			<div class="selbtngroup" [style.height]="opts.height">
				@if (opts.showDecreaseDateBtn) {
					<button
						class="btndecrease"
						type="button"
						[attr.aria-label]="opts.ariaLabelDecreaseDate"
						[disabled]="opts.componentDisabled"
						[ngClass]="{
							btndecreaseenabled: !opts.componentDisabled,
							btndecreasedisabled: opts.componentDisabled,
							btnleftborderradius: !opts.showInputField,
						}"
						(click)="onDecreaseBtnClicked()"
					>
						<span class="mydpicon icon-mydpleft"></span>
					</button>
				}
				@if (opts.showIncreaseDateBtn) {
					<button
						class="btnincrease"
						type="button"
						[attr.aria-label]="opts.ariaLabelIncreaseDate"
						[disabled]="opts.componentDisabled"
						[ngClass]="{
							btnincreaseenabled: !opts.componentDisabled,
							btnincreasedisabled: opts.componentDisabled,
							btnleftborderradius: !opts.showDecreaseDateBtn && !opts.showInputField,
						}"
						(click)="onIncreaseBtnClicked()"
					>
						<span class="mydpicon icon-mydpright"></span>
					</button>
				}
				@if (selectionDayTxt.length > 0 && opts.showClearDateBtn) {
					<button
						class="btnclear"
						type="button"
						[attr.aria-label]="opts.ariaLabelClearDate"
						[disabled]="opts.componentDisabled"
						[ngClass]="{
							btnclearenabled: !opts.componentDisabled,
							btncleardisabled: opts.componentDisabled,
							btnleftborderradius: !opts.showIncreaseDateBtn && !opts.showDecreaseDateBtn && !opts.showInputField,
						}"
						(click)="removeBtnClicked()"
					>
						<span class="mydpicon icon-mydpremove"></span>
					</button>
				}
				<button
					class="btnpicker"
					type="button"
					[attr.aria-label]="opts.ariaLabelOpenCalendar"
					[disabled]="opts.componentDisabled"
					[ngClass]="{
						btnpickerenabled: !opts.componentDisabled,
						btnpickerdisabled: opts.componentDisabled,
						btnleftborderradius:
							(!opts.showClearDateBtn && !opts.showIncreaseDateBtn && !opts.showDecreaseDateBtn && !opts.showInputField)
							|| (selectionDayTxt.length === 0 && !opts.showInputField),
					}"
					(click)="openBtnClicked()"
				>
					<span class="mydpicon icon-mydpcalendar"></span>
				</button>
			</div>
		</div>
	}
	@if (showSelector || opts.inline) {
		<div
			#selectorEl
			class="selector"
			tabindex="0"
			[mydpfocus]="opts.inline ? '0' : '1'"
			[ngClass]="{
				inlinedp: opts.inline,
				alignselectorright: opts.alignSelectorRight,
				selectorarrow: opts.showSelectorArrow && !opts.inline,
				selectorarrowleft: opts.showSelectorArrow && !opts.alignSelectorRight && !opts.inline,
				selectorarrowright: opts.showSelectorArrow && opts.alignSelectorRight && !opts.inline,
			}"
			[ngStyle]="{ width: opts.selectorWidth, height: opts.selectorHeight, bottom: getSelectorTopPosition() }"
			(keyup)="onCloseSelector($event)"
		>
			<table class="header">
				<tr [hidden]="opts.selectYearOnly || opts.selectMonthOnly">
					<td>
						<div style="float: left">
							@if (!opts.hideMonthArrows) {
								<div class="headerbtncell">
									<button
										class="headerbtn mydpicon icon-mydpleft"
										type="button"
										[attr.aria-label]="opts.ariaLabelPrevMonth"
										[disabled]="prevMonthDisabled"
										[ngClass]="{ headerbtnenabled: !prevMonthDisabled, headerbtndisabled: prevMonthDisabled }"
										(click)="onPrevMonth()"
									></button>
								</div>
							}
							<div class="headermonthtxt">
								<button
									class="headerlabelbtn"
									tabindex="{{ opts.monthSelector ? '0' : '-1' }}"
									type="button"
									[hidden]="opts.selectYearOnly"
									[ngClass]="{ monthlabel: opts.monthSelector }"
									(click)="opts.monthSelector && onSelectMonthClicked($event)"
								>
									{{ visibleMonth.monthTxt }}
								</button>
							</div>
							@if (!opts.hideMonthArrows) {
								<div class="headerbtncell">
									<button
										class="headerbtn mydpicon icon-mydpright"
										type="button"
										[attr.aria-label]="opts.ariaLabelNextMonth"
										[disabled]="nextMonthDisabled"
										[ngClass]="{ headerbtnenabled: !nextMonthDisabled, headerbtndisabled: nextMonthDisabled }"
										(click)="onNextMonth()"
									></button>
								</div>
							}
						</div>
					</td>
					<td>
						@if (opts.showTodayBtn) {
							<button
								class="headertodaybtn"
								type="button"
								[disabled]="disableTodayBtn"
								[ngClass]="{ headertodaybtnenabled: !disableTodayBtn, headertodaybtndisabled: disableTodayBtn }"
								(click)="onTodayClicked()"
							>
								<span class="mydpicon icon-mydptoday"></span>
								<span>{{ opts.todayBtnTxt }}</span>
							</button>
						}
					</td>
					<td>
						<div style="float: right">
							@if (!opts.hideYearArrows) {
								<div class="headerbtncell">
									<button
										class="headerbtn mydpicon icon-mydpleft"
										type="button"
										[attr.aria-label]="opts.ariaLabelPrevYear"
										[disabled]="prevYearDisabled"
										[ngClass]="{ headerbtnenabled: !prevYearDisabled, headerbtndisabled: prevYearDisabled }"
										(click)="onPrevYear()"
									></button>
								</div>
							}
							<div class="headeryeartxt">
								<button
									class="headerlabelbtn"
									tabindex="{{ opts.yearSelector ? '0' : '-1' }}"
									type="button"
									[ngClass]="{ yearlabel: opts.yearSelector }"
									(click)="opts.yearSelector && onSelectYearClicked($event)"
								>
									{{ visibleMonth.year }}
								</button>
							</div>
							@if (!opts.hideYearArrows) {
								<div class="headerbtncell">
									<button
										class="headerbtn mydpicon icon-mydpright"
										type="button"
										[attr.aria-label]="opts.ariaLabelNextYear"
										[disabled]="nextYearDisabled"
										[ngClass]="{ headerbtnenabled: !nextYearDisabled, headerbtndisabled: nextYearDisabled }"
										(click)="onNextYear()"
									></button>
								</div>
							}
						</div>
					</td>
				</tr>
				<tr [hidden]="!opts.selectYearOnly">
					<td style="width: 100%; text-align: center">{{ opts.selectYearText }}</td>
				</tr>
				<tr [hidden]="!opts.selectMonthOnly">
					<td style="padding-left: 30%">
						<div>
							<div class="headerbtncell">
								<button
									class="headerbtn mydpicon icon-mydpleft"
									type="button"
									[attr.aria-label]="opts.ariaLabelPrevYear"
									[disabled]="prevYearDisabled"
									[ngClass]="{ headerbtnenabled: !prevYearDisabled, headerbtndisabled: prevYearDisabled }"
									(click)="onPrevYear()"
								></button>
							</div>
							<div class="headeryeartxt">
								<button
									class="headerlabelbtn"
									tabindex="{{ opts.yearSelector ? '0' : '-1' }}"
									type="button"
									[ngClass]="{ yearlabel: opts.yearSelector }"
									(click)="opts.yearSelector && onSelectYearClicked($event)"
								>
									{{ visibleMonth.year }}
								</button>
							</div>
							<div class="headerbtncell">
								<button
									class="headerbtn mydpicon icon-mydpright"
									type="button"
									[attr.aria-label]="opts.ariaLabelNextYear"
									[disabled]="nextYearDisabled"
									[ngClass]="{ headerbtnenabled: !nextYearDisabled, headerbtndisabled: nextYearDisabled }"
									(click)="onNextYear()"
								></button>
							</div>
						</div>
					</td>
				</tr>
			</table>
			@if (!selectMonth && !selectYear && !opts.selectYearOnly) {
				<table class="caltable">
					<thead>
						<tr>
							@if (opts.showWeekNumbers && opts.firstDayOfWeek === "mo") {
								<th class="weekdaytitle weekdaytitleweeknbr">#</th>
							}
							@for (d of weekDays; track $index) {
								<th class="weekdaytitle" scope="col">{{ d }}</th>
							}
						</tr>
					</thead>
					<tbody>
						@for (w of dates; track $index) {
							<tr [ngClass]="{ currweek: isCurrentWeek(w), selectedweek: isSelectedWeek(w) }">
								@if (opts.showWeekNumbers && opts.firstDayOfWeek === "mo") {
									<td class="daycell daycellweeknbr" (click)="!w.week[0].disabled && onWeekCellClicked(w)">
										{{ w.weekNbr }}
									</td>
								}
								@for (d of w.week; track $index) {
									<td
										class="daycell"
										tabindex="0"
										[ngClass]="{
											currmonth: d.cmo === currMonthId && !d.disabled,
											selectedday:
												selectedDate.day === d.dateObj.day
												&& selectedDate.month === d.dateObj.month
												&& selectedDate.year === d.dateObj.year
												&& d.cmo === currMonthId
												&& !opts.selectWeekOnly,
											disabled: d.disabled,
											tablesingleday: d.cmo === currMonthId && !d.disabled,
										}"
										(click)="!d.disabled && onCellClicked(d); $event.stopPropagation()"
										(keydown)="onCellKeyDown($event, d)"
									>
										@if (d.markedDate.marked) {
											<div class="markdate" [ngStyle]="{ 'background-color': d.markedDate.color }"></div>
										}
										<div
											class="datevalue"
											[ngClass]="{
												prevmonth: d.cmo === prevMonthId,
												currmonth: d.cmo === currMonthId,
												nextmonth: d.cmo === nextMonthId,
												highlight: d.highlight,
											}"
										>
											<span
												[ngClass]="{
													markcurrday: d.currDay && opts.markCurrentDay,
													dimday: d.highlight && (d.cmo === prevMonthId || d.cmo === nextMonthId || d.disabled),
												}"
												>{{ d.dateObj.day }}</span
											>
										</div>
									</td>
								}
							</tr>
						}
					</tbody>
				</table>
			}
			@if (selectMonth) {
				<table class="monthtable">
					<tbody>
						@for (mr of months; track $index) {
							<tr>
								@for (m of mr; track m.nbr) {
									<td
										class="monthcell tablesinglemonth"
										tabindex="0"
										[ngClass]="{ selectedmonth: m.selected, disabled: m.disabled }"
										(click)="!m.disabled && onMonthCellClicked(m); $event.stopPropagation()"
										(keydown)="onMonthCellKeyDown($event, m)"
									>
										<div class="monthvalue" [ngClass]="{ markcurrmonth: m.currMonth && opts.markCurrentMonth }">
											{{ m.name }}
										</div>
									</td>
								}
							</tr>
						}
					</tbody>
				</table>
			}
			@if (selectYear || opts.selectYearOnly) {
				<table class="yeartable">
					<tbody>
						<tr>
							<td class="yearchangebtncell" colspan="5" (click)="$event.stopPropagation()">
								<button
									class="yearchangebtn mydpicon icon-mydpup"
									type="button"
									[disabled]="prevYearsDisabled"
									[ngClass]="{ yearchangebtnenabled: !prevYearsDisabled, yearchangebtndisabled: prevYearsDisabled }"
									(click)="onPrevYears($event, years[0][0].year)"
								></button>
							</td>
						</tr>
						@for (yr of years; track $index) {
							<tr>
								@for (y of yr; track y.year) {
									<td
										class="yearcell tablesingleyear"
										tabindex="0"
										[ngClass]="{ selectedyear: y.year === selectedDate.year, disabled: y.disabled }"
										(click)="!y.disabled && onYearCellClicked(y); $event.stopPropagation()"
										(keydown)="onYearCellKeyDown($event, y)"
									>
										<div class="yearvalue" [ngClass]="{ markcurryear: y.currYear && opts.markCurrentYear }">
											{{ y.year }}
										</div>
									</td>
								}
							</tr>
						}
						<tr>
							<td class="yearchangebtncell" colspan="5" (click)="$event.stopPropagation()">
								<button
									class="yearchangebtn mydpicon icon-mydpdown"
									type="button"
									[disabled]="nextYearsDisabled"
									[ngClass]="{ yearchangebtnenabled: !nextYearsDisabled, yearchangebtndisabled: nextYearsDisabled }"
									(click)="onNextYears($event, years[0][0].year)"
								></button>
							</td>
						</tr>
					</tbody>
				</table>
			}
		</div>
	}
</div>
